import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { TranslocoService } from '@jsverse/transloco';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, map, startWith, takeUntil, timeout } from 'rxjs/operators';
import { Flightinfo } from '../../../../../../../../models/flightModel';
import { OrderBundleType } from '../../../../../../../../models/orderBundle.models';
import { Person, PERSONS } from '../../../../../../../../models/persons';
import { ProductOption, PRODUCT_OPTIONS } from '../../../../../../../../models/productOption';
import { ShuttelbussService } from '../../../../../../../../services/shuttlebuss.service';
import { SnackbarService } from '../../../../../../../../services/snackbar.service';
import { BackOffice24TravelAgencyBottomsheetComponent } from '../../../../../../../../../app/home/admin/back-office24/back-office24-boka/back-office24-travel-agency/back-office24-travel-agency-bottomsheet/back-office24-travel-agency-bottomsheet.component';
import { ParkingService } from '../../../../../../../../services/parking.service';
import { MyConfigOrganization } from '../../../../../../../../models/myConfig';
import { BackOffice24StatesService } from '../../../../../../../../../app/home/admin/back-office24/state/back-office24-states.service';
import { CartService } from '../../../../../../../../../app/services/cart.service';
import { BackOfficeService } from '../../../../../../../../../app/services/backoffice.service';
import { InternalBookingSummaryComponent } from '../internal-booking-summary/internal-booking-summary.component';
import { subHours } from 'date-fns';
import { filterTerminalsByDate } from '../../../../../../../../models/BookingModel';

@Component({
  selector: 'app-quality-internal-booking-form',
  templateUrl: './quality-internal-booking-form.component.html',
  styleUrl: './quality-internal-booking-form.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class QualityInternalBookingFormComponent implements OnInit, OnDestroy {
  public datepipe: DatePipe;
  persons: Person[] = PERSONS;
  productOption: ProductOption[] = PRODUCT_OPTIONS;
  bookingForm: UntypedFormGroup;
  isLoading = false;
  isLoadingArrival = false;
  isLoadingDeparture = false;
  minDepartureDate: Date = new Date();
  minArrivalDate: Date = new Date();
  minTransferDate: Date = new Date();
  minParkingEndDate: Date = new Date();
  arrivalFlights: Flightinfo[] = [];
  departureFlights: Flightinfo[] = [];
  currentUtcTime: string = moment.utc().format();
  selectedArrivalTime: Moment;
  arrivalTerminal: string;
  departureTerminal: string;
  productCode: string;

  timeOptions: string[] = [];
  hotelTimeOptions: string[] = [];
  transferTimeOptions: string[] = [];
  parkingEndTimeOptions: string[] = [];
  hotelArrivalTimeOptions: string[] = [];
  hotelDepartureDateOnly: string | null = null;
  hotelDepartureTimeOnly: string | null = null;
  departureDateDisplay: string = '';

  // split-transfer date/time state
  transferDateOnly: string | null = null;
  transferTimeDisplay: string = '';
  transferDateDisplay: string = '';
  filteredTransferTimeOptions: Observable<string[]>;

  // split-parking end date/time state
  parkingEndDateOnly: string | null = null;
  parkingEndTimeDisplay: string = '';
  parkingEndDateDisplay: string = '';
  filteredParkingEndTimeOptions: Observable<string[]>;

  // autocomplete for hotel departure time
  filteredHotelTimeOptions: Observable<string[]>;

  componentDestroyed$: Subject<boolean> = new Subject();
  filteredOptionsFlightsDepartures: Observable<Flightinfo[]>;
  filteredOptionsFlightsArrivals: Observable<Flightinfo[]>;
  hasAvailableParking = true;
  selectedFlight: Flightinfo = null;
  departHour: number;
  departMinute: number;
  arriveHour: number;
  arriveMinute: number;
  selectedArrival: Flightinfo;
  selectedDeparture: Flightinfo;
  // organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
  shuttleOrganizationId: string = '39218780-069A-4C6B-9925-22365A075C15';
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  showDepHotel: boolean = false;
  useFlightForArrival: boolean = true;
  plannedShuttleBussesDeparture: any[] = [];
  plannedShuttleBussesArrival: any[] = [];
  selectedOrg: any;
  allOrgs: any[] = [];
  isLoadingOrganization: boolean = false;
  rawTerminals: any[] = [
    {
      terminalName: 'Arlanda: Terminal 2 och 3',
      terminalCode: 'T2-3'
    },
    {
      terminalName: 'Arlanda: Terminal 4 och 5',
      terminalCode: 'T4'
    }
  ];

  get terminals(): any[] {
    const transferDate =
      this.hotelDepartureDateOnly ||
      this.bookingForm?.get('departureDate')?.value ||
      this.bookingForm?.get('flightDepartureDate')?.value ||
      this.transferDateOnly ||
      this.bookingForm?.get('departureDateAndTimeForTransfer')?.value ||
      this.bookingForm?.get('arrivalDate')?.value;
    return filterTerminalsByDate(this.rawTerminals, transferDate);
  }
  isLoadingParkings: boolean = false;
  parkings: any[] = [];

  parkingFrom: string;
  parkingTo: string;

  constructor(
    private fb: UntypedFormBuilder,
    private shuttleBussService: ShuttelbussService,
    public snackbar: SnackbarService,
    public translate: TranslocoService,
    private bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    private parkingService: ParkingService,
    private backOfficeService: BackOfficeService,
    public backOffice24StatesService: BackOffice24StatesService,
    private cartService: CartService
  ) {
    this.datepipe = new DatePipe('en-US');
  }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.pipe(
      takeUntil(this.componentDestroyed$)
    ).subscribe(org => {
      this.organization = org;
    });

    this.isLoadingOrganization = true;

    this.backOfficeService.getOrganizations(this.organization.organizationId || 'a848ccd3-fd8d-4035-925e-571ebb4e93e8').pipe(takeUntil(this.componentDestroyed$))
      .subscribe({
        next: (data) => {
          this.selectedOrg = data;
          if (this.selectedOrg?.type == "ParkingOperator" || this.selectedOrg?.type == "TravelAgency" || this.selectedOrg?.type == "ParkingCompany") {
            this.allOrgs.push({
              name: this.selectedOrg?.name,
              organizationId: this.selectedOrg?.id,
            });

            if (this.selectedOrg.organizations && Array.isArray(this.selectedOrg.organizations)) {
              this.selectedOrg.organizations.forEach((subOrg: any) => {
                if (subOrg?.type == "ParkingOperator" || subOrg?.type == "TravelAgency" || subOrg?.type == "ParkingCompany") {
                  this.allOrgs.push({
                    name: subOrg.name,
                    organizationId: subOrg.id,
                  });
                }
              });
            }
          }

          if (this.allOrgs.length > 0) {
            this.bookingForm.patchValue({ organization: this.allOrgs[0] });
            this.selectOrganization({ value: this.allOrgs[0] } as MatSelectChange);
          }

          this.isLoadingOrganization = false;
        },
        error: (error) => {
          this.isLoadingOrganization = false;
        }
      });

    this._initForm();
    this.formReset();

    // Set initial form fields state and subscribe to passenger changes after form is initialized
    this.updateFormFieldsState();

    // Subscribe to passenger changes to enable/disable form fields
    this.bookingForm.get('departurePassengers')?.valueChanges.pipe(
      takeUntil(this.componentDestroyed$)
    ).subscribe(() => {
      this.updateFormFieldsState();
    });

    // build times for the time-dropdown used when hotel toggle is on
    this.generateTimeOptions();

    // wire up filtering for transfer, parking and hotel time fields
    const transferCtrl = this.bookingForm.get('transferTimeOnly')!;
    this.filteredTransferTimeOptions = transferCtrl.valueChanges.pipe(
      startWith(''),
      map(val => this.filterTransferTimeOptions(val))
    );
    const parkingCtrl = this.bookingForm.get('parkingEndTimeOnly')!;
    this.filteredParkingEndTimeOptions = parkingCtrl.valueChanges.pipe(
      startWith(''),
      map(val => this.filterParkingEndTimeOptions(val))
    );
    const hotelCtrl = this.bookingForm.get('hotelDepartureTimeOnly')!;
    this.filteredHotelTimeOptions = hotelCtrl.valueChanges.pipe(
      startWith(''),
      map(val => this.filterHotelTimeOptions(val))
    );

    // whenever any time control updates, recombine the appropriate date/time
    transferCtrl.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.updateTransferDate();
    });
    parkingCtrl.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.updateParkingEndDate();
    });
    hotelCtrl.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe((val: string) => {
      this.hotelDepartureTimeOnly = val;
      this.updateDepartureDate();
    });

    // subscriptions to update min dates
    this.bookingForm.controls['departureDate'].valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(value => {
      if (value) {
        this.minTransferDate = new Date(value);
        this.minTransferDate.setDate(this.minTransferDate.getDate() + 1);
      }
    });

    this.bookingForm.controls['flightDepartureDate'].valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.updateMinArrivalDate());
    this.bookingForm.controls['departureDateAndTimeForTransfer'].valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => this.updateMinArrivalDate());

    this.bookingForm.controls['arrivalDate'].valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(value => {
      if (value) {
        this.minParkingEndDate = new Date(value);
      }
    });

    this.bookingForm.valueChanges.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.updateContinueBookingWithPriceState();
    });
    this.updateContinueBookingWithPriceState();
  }

  getAvailableParkingsForOrganization(periodFrom: string, periodTo: string, discountCode: string) {
    this.isLoadingParkings = true;
    let orgId = this.organization?.organizationId;

    // Reset parking selection when recalculating
    this.bookingForm.controls['parking'].reset('');

    this.cartService
      .getAvailableParkings(orgId, periodFrom, periodTo, discountCode)
      .pipe(
        timeout(30000),
        catchError(error => {
          if (error.name === 'TimeoutError') {
            console.error('API call timed out after 30 seconds');
            this.isLoadingParkings = false;
            // this.bookingForm.get('parking')?.setErrors({ timeout: true });
            return of(null);
          }
          return throwError(() => error);
        })
      )
      .subscribe(parkings => {
        this.isLoadingParkings = false;
        this.parkings = parkings?.parkings?.reverse();
        this.parkings = parkings?.parkings?.filter((parking: any) => parking.subscriptionParking == false);

        // if (discountCode != 'NONE') {
        //   this.isDiscountCodeWrong = !this.parkings.some((parking: any) => parking.discountCheckAmount > 0 || parking.discountCheckPercent > 0);
        // }

      });
  }

  onDepartureNumberChange(searchValue: string): void {
    // Only reset selectedFlight if user is actually typing (not just focusing)
    if (searchValue !== this.bookingForm.get('flightDepartureNumber')?.value) {
      this.selectedFlight = null;
    }
  }

  getParkingTime(event: MatSelectChange) {
    this.departHour = moment(event.value).get('hour');
    this.departMinute = moment(event.value).get('minute');
  }

  private _initForm() {
    this.bookingForm = this.fb.group({

      organization: ['', Validators.required],

      isDepartureHotel: [false],
      flightDepartureDate: ['', Validators.required],
      departurePassengers: ['', Validators.required],
      departureFlight: ['', Validators.required],
      departureRoute: ['', Validators.required],
      departureStartDateAndTime: ['', Validators.required],
      departureDate: ['', Validators.required],
      departureDateAndTimeForTransfer: ['', Validators.required],
      transferDateOnly: [''],
      transferTimeOnly: [''],
      parkingEndDateOnly: [''],
      parkingEndTimeOnly: [''],
      hotelDepartureTimeOnly: [''],
      departureTerminal: ['', Validators.required],
      isArrivalHotel: [true],
      isArrivalByFlight: ['flight'],
      arrivalDate: ['', Validators.required],
      arrivalFlight: ['', Validators.required],
      arrivalTerminal: ['', Validators.required],
      arrivalRoute: ['', Validators.required],
      parkingEndDateAndTime: ['', Validators.required],

      flightDepartureNumber: ['', [Validators.pattern(/^\S*$/), Validators.required]],
      selectedShuttleBusDeparture: [''],
      selectedShuttleBusArrival: [''],
      departurePickup: [''],
      arrivalPickup: [''],
      flightArrivalNumber: ['', [Validators.required]],
      flightArrivalId: ['', [Validators.pattern(/^\S*$/), Validators.required]],
      parking: ['', Validators.required],

      bookingNumber: ['', Validators.required],
      carId: ['XXX123', [Validators.required, Validators.minLength(6)]],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      cellular: ['', Validators.required],
      persons: ['', Validators.required],
      onlyHandBaggage: [0],
      overrideParking: [false],
      comment: [''],
      continueBookingWithPrice: [{ value: false, disabled: true }],
      customPrice: [{ value: '', disabled: true }]
    });
  }

  selectOrganization(event: MatSelectChange) {
    this.organization = event?.value;
  }

  get bookingtForm() {
    return this.bookingForm.controls;
  }

  get isPassengersSelected(): boolean {
    return this.bookingForm ? !!this.bookingForm.get('departurePassengers')?.value : false;
  }

  private updateFormFieldsState(): void {
    if (!this.bookingForm) return;

    const isPassengersSelected = this.isPassengersSelected;
    const fieldsToToggle = [
      'flightDepartureDate', 'flightDepartureNumber', 'selectedShuttleBusDeparture',
      'departureStartDateAndTime', 'hotelDepartureTimeOnly', 'transferTimeOnly',
      'transferDateOnly', 'departureTerminal', 'isArrivalByFlight', 'arrivalDate',
      'flightArrivalNumber', 'selectedShuttleBusArrival', 'arrivalTerminal',
      'isArrivalHotel', 'parkingEndTimeOnly', 'parkingEndDateOnly', 'parking',
      'bookingNumber', 'carId', 'firstName', 'lastName', 'cellular',
      'onlyHandBaggage', 'comment', 'overrideParking'
    ];

    fieldsToToggle.forEach(fieldName => {
      const control = this.bookingForm.get(fieldName);
      if (control) {
        if (isPassengersSelected) {
          control.enable({ emitEvent: false });
        } else {
          control.disable({ emitEvent: false });
        }
      }
    });

    // Force update the component state variables
    if (isPassengersSelected) {
      // Re-enable the hotel toggle and arrival type selection
      this.showDepHotel = this.bookingForm.controls['isDepartureHotel'].value;
      this.useFlightForArrival = this.bookingForm.controls['isArrivalByFlight'].value === 'flight';
    }
  }

  formReset() {
    this.shuttleBussService.onFormReset.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.resetForm();
    });
  }

  private _filterAutocompleteDepartures(value: string | any): Flightinfo[] {
    if (typeof value === 'object' && value?.flightId) {
      return this.departureFlights;
    }
    if (!value || typeof value !== 'string') {
      return this.departureFlights;
    }
    const filterValue = value.toLowerCase();
    return this.departureFlights.filter(
      option =>
        option.flightId.toLowerCase().includes(filterValue) ||
        option.arrivalAirportSwedish.toLowerCase().includes(filterValue) ||
        option.arrivalAirportEnglish.toLowerCase().includes(filterValue) ||
        option.codeShareData
          .toString()
          .toLowerCase()
          .includes(filterValue)
    );
  }

  private _filterAutocompleteArrivals(value: string | any): Flightinfo[] {
    if (typeof value === 'object' && value?.flightId) {
      return this.arrivalFlights;
    }
    if (!value || typeof value !== 'string') {
      return this.arrivalFlights;
    }
    const filterValue = value.toLowerCase();
    return this.arrivalFlights.filter(
      option =>
        option.flightId.toLowerCase().includes(filterValue) ||
        option.departureAirportSwedish.toLowerCase().includes(filterValue) ||
        option.departureAirportEnglish.toLowerCase().includes(filterValue) ||
        option.codeShareData
          .toString()
          .toLowerCase()
          .includes(filterValue)
    );
  }

  onArrivalSelect(event: MatOptionSelectionChange) {
    const arrivalFlight = this.arrivalFlights.filter(
      flight => flight.flightId === event.source.value
    );
    this.bookingForm.controls['arrivalFlight'].setValue(arrivalFlight);
    const flightArrivalNumber = arrivalFlight[0].flightId + ' ' + (this.translate.getActiveLang() === 'sv' ? arrivalFlight[0].departureAirportSwedish : arrivalFlight[0].departureAirportEnglish) + ' Kl: ' + moment(arrivalFlight[0].arrivalTime.scheduled).format('HH:mm');
    this.bookingForm.controls['flightArrivalNumber'].setValue(flightArrivalNumber);
    this.selectedArrival = arrivalFlight[0];
    this.arrivalTerminal = arrivalFlight[0].locationAndStatus.terminal;
    this.selectedArrivalTime = moment(arrivalFlight[0].arrivalTime.scheduled);

    // Reset parking when arrival flight changes
    this.bookingForm.controls['parking'].reset('');
    this.parkings = [];

    this.fetchArrShuttleBusses();
  }

  onDepartureTerminalSelect(event: MatSelectChange) {
    this.bookingForm.controls['departureTerminal'].setValue(event.value);
    this.calculateParkingDates();
  }

  onArrivalTerminalSelect(event: MatSelectChange) {
    this.bookingForm.controls['arrivalTerminal'].setValue(event.value);
    this.calculateParkingDates();
  }

  onDepartureSelect(event: MatOptionSelectionChange) {
    if (!event.isUserInput) return;

    const departureFlight = this.departureFlights.filter(
      flight => flight.flightId === event.source.value
    );
    this.bookingForm.controls['departureFlight'].setValue(departureFlight);
    const flightDepartureNumber = departureFlight[0].flightId + ' ' + (this.translate.getActiveLang() === 'sv' ? departureFlight[0].arrivalAirportSwedish : departureFlight[0].arrivalAirportEnglish) + ' Kl: ' + moment(departureFlight[0].departureTime.scheduled).format('HH:mm');
    this.bookingForm.controls['flightDepartureNumber'].setValue(flightDepartureNumber);
    this.selectedFlight = departureFlight[0];

    // Reset related fields when flight is changed (case 1)
    this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
    this.bookingForm.controls['departurePickup'].reset('');
    this.bookingForm.controls['departureStartDateAndTime'].reset('');
    this.bookingForm.controls['parking'].reset('');
    this.parkings = [];

    this.fetchDepShuttleBusses();
  }

  fetchDepShuttleBusses() {
    const depFlight: any = (this.bookingForm.controls['departureFlight'].value) ? (this.bookingForm.controls['departureFlight'].value)[0] : null;
    const depDateAndTimeForTransfer = this.bookingForm.controls['departureDateAndTimeForTransfer'].value;
    if (!this.showDepHotel) {
      if (depFlight) {
        var offsetDateStart = new Date(new Date(depFlight?.departureTime?.scheduled).getTime() - 210 * 60000); // 3.5 hours before
        var offsetDateEnd = new Date(new Date(depFlight?.departureTime?.scheduled).getTime() - 60 * 60000); // 1 hour before
        this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
      }
    } else {
      var offsetDateStart = new Date(new Date(depDateAndTimeForTransfer).getTime() - 60 * 60000); // 1 hour before
      var offsetDateEnd = new Date(new Date(depDateAndTimeForTransfer).getTime() + 60 * 60000); // 1 hour after
      this.getPlannedOrderShuttleBusTypeDeparture(this.formatDate(offsetDateStart), this.formatDate(offsetDateEnd));
    }
  }

  getPlannedOrderShuttleBusTypeDeparture(startDate: string, endDate: string) {
    const selectedPassengers = this.bookingForm.controls['departurePassengers'].value;
    this.plannedShuttleBussesDeparture = [];
    this.shuttleBussService
      .getPlannedOrderShuttleBusType('QUALITYARLDEP', startDate, endDate, 'quality-hotel-xpo-arlanda-airport-transfer')
      .subscribe(plannedShuttleBusses => {
        if (!plannedShuttleBusses || plannedShuttleBusses.length === 0) {
          this.plannedShuttleBussesDeparture = [];
          return;
        }
        plannedShuttleBusses.forEach(shuttle => {
          shuttle.startDate = moment(shuttle.startDate).isValid() ? moment(shuttle.startDate) : moment();
        });
        this.plannedShuttleBussesDeparture = plannedShuttleBusses.filter(shuttle => {
          return shuttle.startDate.isAfter(moment().add(20, 'm')) && (shuttle.seats == null
            || (shuttle.seats - shuttle.passengers >= selectedPassengers)
          );
        });
        if (this.plannedShuttleBussesDeparture.length < 3) {
          const newEndDate = moment(endDate).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');
          this.getPlannedOrderShuttleBusTypeDeparture(startDate, newEndDate);
        }

      });
  }

  fetchArrShuttleBusses() {
    const useFlightForArrival = this.bookingForm.controls['isArrivalByFlight'].value;
    if (useFlightForArrival === true || useFlightForArrival === 'flight') {
      const arrFlight: any = (this.bookingForm.controls['arrivalFlight'].value) ? (this.bookingForm.controls['arrivalFlight'].value)[0] : null;
      if (arrFlight && arrFlight.arrivalTime?.scheduled) {
        const baseDate = new Date(arrFlight.arrivalTime.scheduled);
        const offsetDateStart = new Date(baseDate.getTime() + 45 * 60000);
        const offsetDateEnd = new Date(baseDate.getTime() + 45 * 60000 + 3600000);
        const startDate = this.formatDate(offsetDateStart);
        const endDate = this.formatDate(offsetDateEnd);
        this.getPlannedOrderShuttleBusTypeArrival(startDate, endDate);
      }
    } else {
      const arrivalDate = this.bookingForm.controls['arrivalDate'].value;
      if (arrivalDate) {
        this.bookingForm.controls['parking'].reset('');
        this.parkings = [];

        var offsetDateStart = new Date(arrivalDate);
        offsetDateStart.setHours(0, 0, 0, 0);
        var offsetDateEnd = new Date(arrivalDate);
        offsetDateEnd.setHours(23, 59, 59, 999);
        const startDate = this.formatDate(offsetDateStart);
        const endDate = this.formatDate(offsetDateEnd);
        this.getPlannedOrderShuttleBusTypeArrival(startDate, endDate);
      }
    }
  }

  getPlannedOrderShuttleBusTypeArrival(startDate: string, endDate: string) {
    const selectedPassengers = this.bookingForm.controls['departurePassengers'].value;
    this.plannedShuttleBussesArrival = [];
    this.shuttleBussService
      .getPlannedOrderShuttleBusType('QUALITYARLARR', startDate, endDate, 'quality-hotel-xpo-arlanda-hotel-transfer')
      .subscribe(plannedShuttleBusses => {
        if (!plannedShuttleBusses || plannedShuttleBusses.length === 0) {
          this.plannedShuttleBussesArrival = [];
          return;
        }
        plannedShuttleBusses.forEach(shuttle => {
          shuttle.startDate = moment(shuttle.startDate).isValid() ? moment(shuttle.startDate) : moment();
        });
        this.plannedShuttleBussesArrival = plannedShuttleBusses.filter(shuttle => {
          return shuttle.startDate.isAfter(moment().add(20, 'm')) && (shuttle.seats == null
            || (shuttle.seats - shuttle.passengers >= selectedPassengers)
          );
        });
        if (this.plannedShuttleBussesArrival.length < 3) {
          const newEndDate = moment(endDate).add(2, 'hours').format('YYYY-MM-DDTHH:mm:ss');
          this.getPlannedOrderShuttleBusTypeArrival(startDate, newEndDate);
        }
      });
  }

  setShuttleBus(route: any, type: string) {
    this.bookingForm.controls[type + 'Route']?.setValue(route);
    if (type === 'departure') {
      this.bookingForm.controls['selectedShuttleBusDeparture'].setValue(route);
      if (route?.startDate) {
        this.bookingForm.controls['departurePickup'].setValue(this.formatDateTime(route.startDate.toDate()));
        if (!this.showDepHotel) {
          const date = route.startDate.clone();
          const parkingStartDate = ((date).subtract(1, 'hour')).format('YYYY-MM-DDTHH:mm:ss');
          this.bookingForm.controls['departureStartDateAndTime']?.setValue(parkingStartDate);
        }
      }
      this.calculateParkingDates();
    }
    if (type === 'arrival') {
      this.bookingForm.controls['selectedShuttleBusArrival'].setValue(route);
      if (route?.startDate) {
        this.bookingForm.controls['arrivalPickup'].setValue(this.formatDateTime(route.startDate.toDate()));
      }
      this.calculateParkingDates();
    }
  }

  calculateParkingDates() {
    const isDepartureHotel = this.bookingForm.controls['isDepartureHotel'].value;
    const isArrivalHotel = this.bookingForm.controls['isArrivalHotel'].value;

    // Don't show snackbar if form is being reset or if no passengers selected
    if (!this.isPassengersSelected) {
      return false;
    }

    if (isArrivalHotel == false && isDepartureHotel == false) {
      const message = this.translate.translate('QUALITY_HOTEL.CHOOSE_HOTEL_CONDITION');
      this.snackbar.openSnackBar(
        message,
        'OK'
      );
      return false;
    }

    const validationResult = this.validateFormCompletion();
    if (!validationResult.isValid) {
      return false;
    }

    // Proceed with parking date calculations
    let parkingStartDateTime: string = '';
    let parkingEndDateTime: string = '';

    // Determine parking start date
    if (isDepartureHotel == true) {
      // Use departure date time for transfer
      parkingStartDateTime = this.formatDateTime(this.bookingForm.controls['departureDate'].value);
    } else {
      // Use departure pickup time from route
      parkingStartDateTime = this.bookingForm.controls['departureStartDateAndTime'].value;
      if (!parkingStartDateTime && this.bookingForm.controls['selectedShuttleBusDeparture'].value?.startDate) {
        const route = this.bookingForm.controls['selectedShuttleBusDeparture'].value;
        const date = route.startDate.clone();
        parkingStartDateTime = date.subtract(1, 'hour').format('YYYY-MM-DDTHH:mm:ss');
        this.bookingForm.controls['departureStartDateAndTime']?.setValue(parkingStartDateTime);
      }
    }

    // Determine parking end date
    if (isArrivalHotel) {
      if (!this.bookingForm.controls['parkingEndDateAndTime'].value) {
        this.updateParkingEndDate();
      }
      const endDateVal = this.bookingForm.controls['parkingEndDateAndTime'].value;
      if (endDateVal) {
        parkingEndDateTime = this.formatDateTime(endDateVal);
      } else {
        let arrivalRoute = this.bookingForm.controls['selectedShuttleBusArrival'].value;
        if (arrivalRoute?.startDate) {
          const date = arrivalRoute.startDate.toDate();
          date.setHours(date.getHours() + 1);
          parkingEndDateTime = this.formatDateTime(date);
        } else {
          parkingEndDateTime = '';
        }
      }
    } else {
      let arrivalRoute = this.bookingForm.controls['selectedShuttleBusArrival'].value;
      // Use arrival pickup time from route
      if (arrivalRoute?.startDate) {
        const date = arrivalRoute.startDate.toDate();
        date.setHours(date.getHours() + 1);
        parkingEndDateTime = this.formatDateTime(date);
      } else {
        parkingEndDateTime = '';
      }
    }

    this.parkingFrom = parkingStartDateTime;
    this.parkingTo = parkingEndDateTime;

    if (parkingStartDateTime && parkingEndDateTime) {
      this.getAvailableParkingsForOrganization(parkingStartDateTime, parkingEndDateTime, 'NONE');
    }
  }

  validateFormCompletion(): { isValid: boolean, isDepartureComplete: boolean, isArrivalComplete: boolean } {
    const isDepartureHotel = this.bookingForm.controls['isDepartureHotel'].value;
    const isArrivalHotel = this.bookingForm.controls['isArrivalHotel'].value;
    const useFlightForArrival = this.bookingForm.controls['isArrivalByFlight'].value === 'flight' || this.bookingForm.controls['isArrivalByFlight'].value === true;

    let isDepartureComplete = false;
    let isArrivalComplete = false;

    const departureFlightDate = this.bookingForm.controls['flightDepartureDate'].value;
    const departurePassengers = this.bookingForm.controls['departurePassengers'].value;
    const departureFlight = this.bookingForm.controls['departureFlight'].value;
    const selectedShuttleBusDeparture = this.bookingForm.controls['selectedShuttleBusDeparture'].value;
    const departureDatetimeForTransfer = this.bookingForm.controls['departureDateAndTimeForTransfer'].value;
    const departureDatetime = this.bookingForm.controls['departureDate'].value;
    const departureTerminal = this.bookingForm.controls['departureTerminal'].value;

    const arrivalDate = this.bookingForm.controls['arrivalDate'].value;
    const arrivalFlight = this.bookingForm.controls['arrivalFlight'].value;
    const selectedShuttleBusArrival = this.bookingForm.controls['selectedShuttleBusArrival'].value;
    const arrivalTerminal = this.bookingForm.controls['arrivalTerminal'].value;
    const parkingEndDatetime = this.bookingForm.controls['parkingEndDateAndTime'].value;

    if (isDepartureHotel) {
      isDepartureComplete = !!(departureDatetime && departurePassengers && departureDatetimeForTransfer && selectedShuttleBusDeparture && departureTerminal);
    } else {
      isDepartureComplete = !!(departureFlightDate && departurePassengers && departureFlight && selectedShuttleBusDeparture);
    }

    if (useFlightForArrival) {
      isArrivalComplete = !!(arrivalDate && departurePassengers && arrivalFlight && selectedShuttleBusArrival);
    } else {
      isArrivalComplete = !!(arrivalDate && departurePassengers && arrivalTerminal && selectedShuttleBusArrival);
    }

    if (isArrivalHotel && parkingEndDatetime) {
      isArrivalComplete = isArrivalComplete && !!parkingEndDatetime;
    }

    return {
      isValid: isDepartureComplete && isArrivalComplete,
      isDepartureComplete,
      isArrivalComplete
    };
  }

  isFormCompleteForSubmission(): boolean {
    // Check basic required fields
    const organization = this.bookingForm.controls['organization'].value;
    const email = this.bookingForm.controls['email'].value;
    const bookingNumber = this.bookingForm.controls['bookingNumber'].value;
    const cellular = this.bookingForm.controls['cellular'].value;
    const carId = this.bookingForm.controls['carId'].value;
    const lastName = this.bookingForm.controls['lastName'].value;
    const firstName = this.bookingForm.controls['firstName'].value;
    const parking = this.bookingForm.controls['parking'].value;

    const basicFieldsComplete = organization && email && bookingNumber && cellular && carId && lastName && firstName && parking;

    // Check departure and arrival completion
    const validationResult = this.validateFormCompletion();

    return basicFieldsComplete && validationResult.isValid;
  }

  get parking(): any {
    return this.bookingForm?.get('parking')?.value;
  }

  get selectedParking(): any {
    return this.bookingForm?.get('parking')?.value;
  }

  get calculatedPrice(): number {
    return this.bookingForm?.get('parking')?.value?.totalPrice || 0;
  }

  isBookingFormValid(): boolean {
    return this.isFormCompleteForSubmission();
  }

  updateContinueBookingWithPriceState() {
    const continueCtrl = this.bookingForm?.get('continueBookingWithPrice');
    const isValid = this.isBookingFormValid();
    if (!isValid) {
      if (continueCtrl?.value) {
        continueCtrl.setValue(false, { emitEvent: false });
        this.bookingForm.get('customPrice')?.setValue('', { emitEvent: false });
      }
      if (continueCtrl?.enabled) {
        continueCtrl.disable({ emitEvent: false });
      }
    } else {
      if (continueCtrl?.disabled) {
        continueCtrl.enable({ emitEvent: false });
      }
    }
  }

  checkContinueBookingWithPrice(e: MatCheckboxChange) {
    this.bookingForm.controls['continueBookingWithPrice'].setValue(e.checked);
    const customPriceCtrl = this.bookingForm.get('customPrice');
    if (e.checked) {
      customPriceCtrl?.enable();
      if (customPriceCtrl && (customPriceCtrl.value === '' || customPriceCtrl.value === null || customPriceCtrl.value === undefined)) {
        customPriceCtrl.setValue(this.calculatedPrice);
      }
    } else {
      customPriceCtrl?.disable();
      customPriceCtrl?.setValue('');
    }
  }

  checkBaggage(e: MatCheckboxChange) {
    if (e.checked) {
      this.bookingForm.controls['onlyHandBaggage'].setValue(1);
    }
    if (!e.checked) {
      this.bookingForm.controls['onlyHandBaggage'].setValue(0);
    }
  }

  checkOverrideParking(e: MatCheckboxChange) {
    this.bookingForm.controls['overrideParking'].setValue(e.checked);
    if (this.bookingForm.controls['overrideParking'].value) {
      this.hasAvailableParking = true;
    }
  }

  onArrivalTypeChange(value: string) {
    this.useFlightForArrival = value === 'flight';
    this.plannedShuttleBussesArrival = [];
    this.bookingForm.controls['arrivalDate'].reset('');
    this.bookingForm.controls['selectedShuttleBusArrival'].reset('');
    if (this.useFlightForArrival) {
      this.bookingForm.controls['arrivalFlight'].reset('');
      this.bookingForm.controls['flightArrivalNumber'].reset('');
      this.bookingForm.controls['flightArrivalId'].reset('');
    } else {
      this.bookingForm.controls['arrivalTerminal'].reset('');
    }
  }

  toggleHotelUponReturn(event: any) {
    this.bookingForm.controls['isArrivalHotel'].setValue(event.checked);
    this.calculateParkingDates();
  }

  resetForm() {
    // Reset form to initial state
    this.bookingForm.reset({
      carId: 'XXX123',
      isDepartureHotel: false,
      isArrivalHotel: true,
      isArrivalByFlight: 'flight',
      continueBookingWithPrice: false,
      customPrice: ''
    });
    this.bookingForm.get('continueBookingWithPrice')?.disable();
    this.bookingForm.get('customPrice')?.disable();

    // Reset component state variables
    this.showDepHotel = false;
    this.useFlightForArrival = true;
    this.selectedFlight = null;
    this.selectedArrival = null;
    this.selectedDeparture = null;
    this.selectedOrg = null;
    this.hasAvailableParking = true;
    this.isLoading = false;
    this.isLoadingArrival = false;
    this.isLoadingDeparture = false;
    this.isLoadingParkings = false;

    // Reset arrays
    this.arrivalFlights = [];
    this.departureFlights = [];
    this.plannedShuttleBussesDeparture = [];
    this.plannedShuttleBussesArrival = [];
    this.parkings = [];

    // Reset date/time state variables
    this.hotelDepartureDateOnly = null;
    this.hotelDepartureTimeOnly = null;
    this.departureDateDisplay = '';
    this.transferDateOnly = null;
    this.transferTimeDisplay = '';
    this.transferDateDisplay = '';
    this.parkingEndDateOnly = null;
    this.parkingEndTimeDisplay = '';
    this.parkingEndDateDisplay = '';
    this.parkingFrom = '';
    this.parkingTo = '';

    // Reset terminal variables
    this.arrivalTerminal = '';
    this.departureTerminal = '';

    // Reset min dates to current date
    this.minDepartureDate = new Date();
    this.minArrivalDate = new Date();
    this.minTransferDate = new Date();
    this.minParkingEndDate = new Date();

    // Set organization back to first available if exists
    if (this.allOrgs.length > 0) {
      this.bookingForm.patchValue({ organization: this.allOrgs[0] });
      this.selectOrganization({ value: this.allOrgs[0] } as MatSelectChange);
    }

    // Update form fields state after a short delay to ensure form is properly reset
    setTimeout(() => {
      this.updateFormFieldsState();
    }, 100);

    // Scroll to top
    window.scroll(0, 0);
  }

  getFlightsByDate(date: any, type: string) {
    const pickedDate = date.value.format('YYYY-MM-DD');
    if (type === 'departure') {
      this.minArrivalDate = pickedDate;
      this.isLoadingDeparture = true;

      // Reset related fields when departure date is changed (case 2)
      this.bookingForm.controls['flightDepartureNumber'].reset('');
      this.bookingForm.controls['departureFlight'].reset('');
      this.bookingForm.controls['departurePickup'].reset('');
      this.bookingForm.controls['departureStartDateAndTime'].reset('');
      this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
      this.bookingForm.controls['departureRoute'].reset('');
      this.bookingForm.controls['parking'].reset('');
      this.selectedFlight = null;
      this.parkings = [];

      this.shuttleBussService
        .getFlights(pickedDate, type)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          flightInfo => {
            this.departureFlights = flightInfo
              .filter(
                flight =>
                  flight.departureTime.scheduled > moment().format()
              )
              .sort((a, b) =>
                a.departureTime.scheduled < b.departureTime.scheduled ? -1 : 1
              );
            this.isLoadingDeparture = false;
            this.filteredOptionsFlightsDepartures = this.bookingForm.controls[
              'flightDepartureNumber'
            ].valueChanges.pipe(
              startWith(''),
              map(value => this._filterAutocompleteDepartures(value))
            );
          },
          error => {
            this.isLoadingDeparture = false;
            console.error(error);
            this.snackbar.openSnackBar(
              `Det gick inte att hämta flightnummer, vänligen försök igen - (${error.statusText})`,
              ''
            );
          }
        );
    }
    if (type === 'arrival') {
      this.isLoadingArrival = true;

      // Reset related fields when arrival flight date is changed (case 1)
      this.bookingForm.controls['arrivalFlight'].reset('');
      this.bookingForm.controls['flightArrivalNumber'].reset('');
      this.bookingForm.controls['flightArrivalId'].reset('');
      this.bookingForm.controls['arrivalRoute'].reset('');
      this.bookingForm.controls['parkingEndDateAndTime'].reset('');
      this.bookingForm.controls['selectedShuttleBusArrival'].reset('');
      this.bookingForm.controls['arrivalPickup'].reset('');
      this.bookingForm.controls['parking'].reset('');
      // Reset parking end date and time fields when arrival date changes
      this.bookingForm.controls['parkingEndDateOnly'].reset('');
      this.bookingForm.controls['parkingEndTimeOnly'].reset('');
      this.parkingEndDateOnly = null;
      this.parkingEndTimeDisplay = '';
      this.parkingEndDateDisplay = '';
      this.selectedArrival = null;
      this.parkings = [];

      this.shuttleBussService
        .getFlights(pickedDate, type)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(
          flightInfo => {
            this.arrivalFlights = flightInfo
              .filter(
                flight =>
                  flight.arrivalTime.scheduled > moment().format()
              )
              .sort((a, b) => (a.arrivalTime.scheduled < b.arrivalTime.scheduled ? -1 : 1));
            this.isLoadingArrival = false;
            this.filteredOptionsFlightsArrivals = this.bookingForm.controls[
              'flightArrivalNumber'
            ].valueChanges.pipe(
              startWith(''),
              map(value => this._filterAutocompleteArrivals(value))
            );
          },
          error => {
            this.isLoadingArrival = false;
            console.error(error);
            this.snackbar.openSnackBar(
              `Det gick inte att hämta flightnummer, vänligen försök igen - (${error.statusText})`,
              ''
            );
          }
        );
    }
  }

  openBottomSheet() {
    if (!this.parkingFrom || !this.parkingTo) {
      this.calculateParkingDates();
    }
    let baggageVar = 0;
    if (this.bookingForm.controls['onlyHandBaggage'].value === 1) {
      baggageVar = 1;
    }
    const isContinueBookingWithPrice = this.bookingForm.controls['continueBookingWithPrice']?.value ?? false;
    const customPriceInput = this.bookingForm.controls['customPrice']?.value;
    const resolvedPrice = isContinueBookingWithPrice
      ? (customPriceInput !== null && customPriceInput !== undefined && customPriceInput !== '' ? Number(customPriceInput) : this.calculatedPrice)
      : this.calculatedPrice;

    const customerData: any = {
      order: {
        organizationId: this.organization?.organizationId,
        bundleCode: this.bookingForm.controls['parking']?.value?.bundleCode,
        productCode: this.bookingForm.controls['parking']?.value?.productCode,
        externalBookingReference: this.bookingForm.controls['bookingNumber']?.value,
        shuttleOrganizationId: this.shuttleOrganizationId,
        comment: this.bookingForm.controls['comment'].value ?? ""
      },
      customer: {
        firstname: this.bookingForm.controls['firstName'].value,
        lastname: this.bookingForm.controls['lastName'].value,
        email: this.bookingForm.controls['email'].value ?? "",
        cellular: this.bookingForm.controls['cellular'].value ?? ""
      },
      parking: {
        parkingId: this.bookingForm.controls['parking']?.value?.id,
        productCode: this.bookingForm.controls['parking']?.value?.productCode,
        carId: this.bookingForm.controls['carId'].value,
        parkingFrom: this.parkingFrom,
        parkingTo: (this.bookingForm.controls['isArrivalHotel'].value && this.bookingForm.controls['parkingEndDateAndTime'].value)
          ? this.parkingTo
          : (this.parkingTo ? this.formatDate(subHours(new Date(this.parkingTo), 1)) : ''),
        extendPeriod: 0,
        passengers: this.bookingForm.controls['departurePassengers'].value,
        parkingCapacityMultiplier: this.bookingForm.controls['parking']?.value?.parkingCapacityMultiplier
      },
      internalBooking: true,
      totalPrice: this.calculatedPrice
    };

    if ((this.bookingForm.controls['parking']?.value.overbooking == true) && this.bookingForm.controls['parking']?.value?.availableParkingSpots <= 0) {
      customerData.parking.overbooked = 1;
    }

    let departureFlightdate: any;
    let arrivalFlightdate: any;
    let departureFlightTerminal: any;
    let arrivalFlightTerminal: any;

    if (this.bookingForm.controls['isDepartureHotel'].value === false) {
      departureFlightdate = this.bookingForm.controls['departureFlight'].value?.[0]?.departureTime?.scheduled
        ? new Date(this.bookingForm.controls['departureFlight'].value?.[0]?.departureTime.scheduled).toString().replace(/\s\(.*\)$/, "")
        : undefined;
      departureFlightTerminal = this.bookingForm.controls['departureFlight'].value?.[0]?.locationAndStatus?.terminal ?? null;
    }

    if (this.bookingForm.controls['isArrivalByFlight'].value == 'flight' || this.bookingForm.controls['isArrivalByFlight'].value == true) {
      arrivalFlightdate = this.bookingForm.controls['arrivalFlight'].value?.[0]?.arrivalTime?.scheduled
        ? new Date(this.bookingForm.controls['arrivalFlight'].value?.[0]?.arrivalTime.scheduled).toString().replace(/\s\(.*\)$/, "")
        : undefined;
      arrivalFlightTerminal = this.bookingForm.controls['arrivalFlight'].value?.[0]?.locationAndStatus?.terminal ?? null;
    }

    customerData.shuttles = [
      {
        stationcode: 'ARN',
        shuttletypecode: 'quality-hotel-xpo-arlanda-airport-transfer',
        productcode: 'QUALITYARLDEP',
        shuttledate: this.bookingForm.controls['departurePickup'].value,
        flightnr: this.bookingForm.controls['flightDepartureNumber'].value || null,
        flightdate: departureFlightdate,
        flightdeparturedate: this.bookingForm.controls['departureFlight'].value?.[0]?.flightLegIdentifier?.flightDepartureDateUtc ?? null,
        flightterminal: departureFlightTerminal ?? null,
        terminal: this.bookingForm.controls['departureTerminal']?.value ? this.bookingForm.controls['departureTerminal']?.value?.terminalCode : departureFlightTerminal,
        ordershuttlebusid: this.bookingForm.controls['departureRoute'].value?.orderShuttleBusId ?? null,
        passengers: (this.bookingForm.controls['departurePassengers'].value),
        childseats: 0,
        baggage: baggageVar,
        comment: this.bookingForm.controls['comment'].value ?? ""
      },
      {
        stationcode: 'ARN',
        shuttletypecode: 'quality-hotel-xpo-arlanda-hotel-transfer',
        productcode: 'QUALITYARLARR',
        shuttledate: this.bookingForm.controls['arrivalPickup'].value,
        flightdate: arrivalFlightdate,
        flightdeparturedate: this.bookingForm.controls['arrivalFlight'].value?.[0]?.flightLegIdentifier?.flightDepartureDateUtc ?? null,
        flightnr: this.bookingForm.controls['flightArrivalNumber'].value || null,
        flightterminal: arrivalFlightTerminal ?? null,
        terminal: this.bookingForm.controls['arrivalTerminal']?.value ? this.bookingForm.controls['arrivalTerminal']?.value?.terminalCode : arrivalFlightTerminal,
        ordershuttlebusid: this.bookingForm.controls['arrivalRoute'].value?.orderShuttleBusId ?? null,
        passengers: (this.bookingForm.controls['departurePassengers'].value),
        childseats: 0,
        baggage: baggageVar,
        comment: this.bookingForm.controls['comment'].value ?? ""
      }
    ]

    this.isLoading = true;
    this.shuttleBussService
      .addOrderBundle(customerData)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(cart => {
        if (cart) {
          this.isLoading = false;
          const sheetRef = this.bottomSheet.open(InternalBookingSummaryComponent, {
            data: {
              cart,
              customer: customerData,
              customPrice: isContinueBookingWithPrice ? resolvedPrice : 0
            },
            panelClass: 'bottom-sheet-container'
          });
          sheetRef
            .afterDismissed()
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(data => {
              if (data && data?.cart?.orderId) {
                this.resetForm();
              }
            });
        }
      },
        (error: any) => {
          console.error(error);
          this.snackbar.openSnackBar(`Något gick fel... (${error.status})`, error.message);
          this.isLoading = false;
        });
  }

  toggleHotel(event: any) {
    this.showDepHotel = event.checked;
    this.bookingForm.controls['isDepartureHotel'].setValue(this.showDepHotel);
    this.plannedShuttleBussesDeparture = [];
    if (this.showDepHotel) {
      // if we previously had a value, decompose it into the two inputs
      const existing: Date = this.bookingForm.controls['departureDate'].value;
      if (existing instanceof Date && !isNaN(existing.getTime())) {
        const iso = existing.toISOString();
        this.hotelDepartureDateOnly = iso.slice(0, 10);
        this.hotelDepartureTimeOnly = iso.slice(11, 16);
        this.bookingForm.controls['hotelDepartureTimeOnly'].setValue(this.hotelDepartureTimeOnly);
        this.departureDateDisplay = this.formatDateTime(existing).replace('T', ' ');
      } else {
        this.bookingForm.controls['departureDate'].reset('');
        this.hotelDepartureDateOnly = null;
        this.hotelDepartureTimeOnly = null;
        this.bookingForm.controls['hotelDepartureTimeOnly'].reset('');
        this.departureDateDisplay = '';
      }
      this.bookingForm.controls['departureTerminal'].reset('');
      this.bookingForm.controls['departureDateAndTimeForTransfer'].reset('');
      this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
      // reset transfer split fields as well
      this.transferDateOnly = null;
      this.bookingForm.controls['transferTimeOnly'].reset('');
      this.transferDateDisplay = '';
    } else {
      this.bookingForm.controls['flightDepartureDate'].reset('');
      this.bookingForm.controls['flightDepartureNumber'].reset('');
      this.bookingForm.controls['departureFlight'].reset('');
      this.bookingForm.controls['departureStartDateAndTime'].reset('');
      this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
      this.bookingForm.controls['departurePickup'].reset('');
    }
  }

  formatDate(sourceDate: Date | string | any): string {
    if (!sourceDate) {
      return '';
    }
    const d = sourceDate instanceof Date ? sourceDate : new Date(sourceDate);
    if (isNaN(d.getTime())) {
      return '';
    }
    const twoDigitMonth = (d.getMonth() + 1).toString().padStart(2, '0');
    const twoDigitDate = d.getDate().toString().padStart(2, '0');
    const twoDigitHour = d.getHours().toString().padStart(2, '0');
    const twoDigitMinute = d.getMinutes().toString().padStart(2, '0');
    return `${d.getFullYear()}-${twoDigitMonth}-${twoDigitDate}T${twoDigitHour}:${twoDigitMinute}:00`;
  }

  formatDateTime(date: Date | string | any): string {
    if (!date) {
      return '';
    }
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) {
      return '';
    }
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  /** update separate date/time fields and combine into departureDate control */
  onHotelDateChange(dateObj: Date) {
    if (dateObj) {
      const dateStr = this.datepipe.transform(dateObj, 'yyyy-MM-dd');
      this.hotelDepartureDateOnly = dateStr;

      // Reset related fields when dep date is changed (case 1)
      this.bookingForm.controls['parkingEndDateAndTime'].reset('');
      this.bookingForm.controls['transferDateOnly'].reset('');
      this.bookingForm.controls['transferTimeOnly'].reset('');
      this.bookingForm.controls['departureDateAndTimeForTransfer'].reset('');
      this.bookingForm.controls['departurePickup'].reset('');
      this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
      this.bookingForm.controls['parking'].reset('');
      this.transferDateOnly = null;
      this.transferDateDisplay = '';
      this.parkings = [];

      this.updateDepartureDate();
    }
  }

  onHotelTimeChange(timeStr: string) {
    this.hotelDepartureTimeOnly = timeStr;
    this.bookingForm.controls['hotelDepartureTimeOnly'].setValue(timeStr);
    this.updateDepartureDate();
  }

  private updateDepartureDate() {
    if (this.hotelDepartureDateOnly && this.hotelDepartureTimeOnly) {
      const combined = `${this.hotelDepartureDateOnly}T${this.hotelDepartureTimeOnly}:00`;
      const dt = new Date(combined);
      if (!isNaN(dt.getTime())) {
        this.bookingForm.controls['departureDate'].setValue(dt);
        // display string without T
        this.departureDateDisplay = combined.replace('T', ' ');
        this.calculateParkingDates();
      }
    }
  }

  // transfer handlers
  onTransferDateChange(dateObj: Date) {
    if (dateObj) {
      const dateStr = this.datepipe.transform(dateObj, 'yyyy-MM-dd');
      this.transferDateOnly = dateStr;

      // Reset related fields when transfer date is changed (case 2)
      this.bookingForm.controls['transferTimeOnly'].reset('');
      this.bookingForm.controls['departurePickup'].reset('');
      this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
      this.bookingForm.controls['parking'].reset('');
      this.parkings = [];

      this.updateTransferDate();
    }
  }

  private updateTransferDate() {
    if (this.transferDateOnly && this.bookingForm.controls['transferTimeOnly'].value) {
      const combined = `${this.transferDateOnly}T${this.bookingForm.controls['transferTimeOnly'].value}:00`;
      const dt = new Date(combined);
      if (!isNaN(dt.getTime())) {
        this.bookingForm.controls['departureDateAndTimeForTransfer'].setValue(dt);
        this.transferDateDisplay = combined.replace('T', ' ');

        // Reset dep pickup time when transfer time is changed (case 3)
        this.bookingForm.controls['departurePickup'].reset('');
        this.bookingForm.controls['selectedShuttleBusDeparture'].reset('');
        this.bookingForm.controls['parking'].reset('');
        this.parkings = [];

        this.fetchDepShuttleBusses();
      }
    }
  }

  onParkingDateChange(dateObj: Date) {
    if (dateObj) {
      const dateStr = this.datepipe.transform(dateObj, 'yyyy-MM-dd');
      this.parkingEndDateOnly = dateStr;
      this.updateParkingEndDate();
    }
  }

  updateParkingEndDate() {
    const dateStr = this.parkingEndDateOnly || (this.bookingForm.controls['arrivalDate'].value ? this.datepipe.transform(this.bookingForm.controls['arrivalDate'].value, 'yyyy-MM-dd') : null);
    const timeVal = this.bookingForm.controls['parkingEndTimeOnly']?.value || '00:00';
    if (dateStr) {
      const combined = `${dateStr}T${timeVal}:00`;
      const dt = new Date(combined);
      if (!isNaN(dt.getTime())) {
        this.bookingForm.controls['parkingEndDateAndTime'].setValue(dt);
        this.parkingEndDateDisplay = combined.replace('T', ' ');
      }
    }
    this.calculateParkingDates();
  }

  private updateMinArrivalDate() {
    const flightDep = this.bookingForm.controls['flightDepartureDate'].value;
    const transferDep = this.bookingForm.controls['departureDateAndTimeForTransfer'].value;
    let maxDate = new Date();
    if (flightDep && flightDep > maxDate) maxDate = new Date(flightDep);
    if (transferDep && transferDep > maxDate) maxDate = new Date(transferDep);
    this.minArrivalDate = maxDate;
  }

  generateTimeOptions() {
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of [0, 15, 30, 45]) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.timeOptions.push(timeString);
        this.hotelTimeOptions.push(timeString);
        // transfer only 00 and 30
        if (minute === 0 || minute === 30) {
          this.transferTimeOptions.push(timeString);
        }
      }
      // parking end minutes 10,30,50
      for (let minute of [10, 30, 50]) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.parkingEndTimeOptions.push(timeString);
      }
    }

    // Generate hotel arrival time options with 10, 30, 50 minutes
    for (let hour = 0; hour < 24; hour++) {
      for (let minute of [10, 30, 50]) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        this.hotelArrivalTimeOptions.push(timeString);
      }
    }
  }

  filterTimeOptions(value: string): string[] {
    if (!value) return this.timeOptions;
    const filterValue = value.toLowerCase();
    return this.timeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  filterHotelTimeOptions(value: string): string[] {
    if (!value) return this.hotelTimeOptions;
    const filterValue = value.toLowerCase();
    return this.hotelTimeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  filterTransferTimeOptions(value: string): string[] {
    if (!value) return this.transferTimeOptions;
    const filterValue = value.toLowerCase();
    return this.transferTimeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  filterParkingEndTimeOptions(value: string): string[] {
    if (!value) return this.parkingEndTimeOptions;
    const filterValue = value.toLowerCase();
    return this.parkingEndTimeOptions.filter(option => option.toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
    this.orgSubscription.unsubscribe();
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
